export default {
  experian: 'https://experian.co.uk',
  helpSection: 'https://consumer.learn.experian.co.uk/IS/s/#_ga=2.124780554.1240472686.1582111073-10954006.1578310621',
};
